export const RECO_BOX_CLAMP_WIDTH = 'clamp(256px, 40vw, 299px)';
// keep aspect-ratio of the box based on the relative width
// this is supported in iOS 14, so no need for aspect-ratio
export const RECO_BOX_CLAMP_HEIGHT = `calc(${RECO_BOX_CLAMP_WIDTH} * 1.4)`;
export const ALTERNATIVE_HOTELS_CONTAINER = 'ALTERNATIVE_HOTELS_CONTAINER';
